import React, { useState } from 'react';
import logo from '../images/logo.jpg';

const Header = () => {
  const [open, setOpen] = useState(false);

  return (
    <header className="main-header">
      <div className="container">
        <div className="navbar">
          <a className="navbar-brand" href="/">
            <img src={logo} alt="Cineflix logo" className="logo" />
          </a>

          <button
            className="nav-toggle"
            type="button"
            aria-label="Toggle navigation"
            onClick={() => setOpen((prev) => !prev)}
          >
            <i className="bi bi-list" />
          </button>

          <nav className={`nav-links-wrapper${open ? ' is-open' : ''}`}>
            <ul className="nav-links">
              <li>
                <a className="nav-link-custom" href="https://cineflixtheater.com/">
                  Home
                </a>
              </li>
              <li>
                <a className="nav-link-custom" href="https://cineflixtheater.com/about-us/">
                  About us
                </a>
              </li>
              <li>
                <a className="nav-link-custom" href="https://cineflixtheater.com/gallery/">
                  Gallery
                </a>
              </li>
              <li>
                <a className="nav-link-custom" href="https://cineflixtheater.com/house-rules/">
                  House Rules
                </a>
              </li>
              <li>
                <a className="nav-link-custom" href="https://cineflixtheater.com/contact/">
                  Contact
                </a>
              </li>
            </ul>
          </nav>

          <a className="btn btn-book-now" href="/">
            Book Now
          </a>
        </div>
      </div>
    </header>
  );
};

export default Header;
